import { Home } from "lucide-react";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
} from "@/components/ui/breadcrumb";

interface PageBreadcrumbProps {
  currentPage: string;
}

const PageBreadcrumb = ({ currentPage }: PageBreadcrumbProps) => {
  return (
    <div className="px-4 sm:px-6 lg:px-8 py-3 border-b bg-white">
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link 
              to="/" 
              className="flex items-center gap-2 text-sm font-medium text-primary hover:text-primary/90"
            >
              <Home className="h-4 w-4" />
              Home
            </Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <BreadcrumbPage className="text-sm">{currentPage}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
};

export default PageBreadcrumb;